import type { z } from 'zod';
import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn, createTransformer } from '../common/utils';
import { DBLegacyTopicGroupSchema, LegacyTopicGroupSchema } from './schemas';

type DBLegacyTopicGroup = z.infer<typeof DBLegacyTopicGroupSchema>;
type LegacyTopicGroup = z.infer<typeof LegacyTopicGroupSchema>;

export const LegacyTopicGroupCodecConfig: TransformerConfig<
  typeof LegacyTopicGroupSchema,
  typeof DBLegacyTopicGroupSchema
> = {
  name: 'LegacyTopicGroup',
  clientSchema: LegacyTopicGroupSchema,
  dbSchema: DBLegacyTopicGroupSchema,
  transformers: [
    // topics: [{ topicId, label }] ↔ topics: { topicId: { key, label } }
    createTransformer<typeof LegacyTopicGroupSchema, typeof DBLegacyTopicGroupSchema>({
      encoder: {
        sourceFields: ['topics'] as const,
        encode: ({ topics }) => ({
          topics: Object.fromEntries(
            (topics as LegacyTopicGroup['topics']).map(t => [
              t.topicId,
              { key: t.topicId, label: t.label },
            ])
          ),
        }),
      },
      decoder: {
        sourceFields: ['topics'] as const,
        decode: ({ topics }) => ({
          topics: Object.entries((topics as DBLegacyTopicGroup['topics']) ?? {}).map(
            ([topicId, { label }]) => ({
              topicId,
              label,
            })
          ),
        }),
      },
    }),
  ],
};

export const encodeLegacyTopicGroupToDb = createEncodeToDbFn(LegacyTopicGroupCodecConfig);
export const decodeLegacyTopicGroupFromDb = createDecodeFromDbFn(LegacyTopicGroupCodecConfig);
